import { AxiosResponse } from "axios";
import { axiosInstance } from "../axios-instance";

const orderServices = {
  requestOtp: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`sendOtp`, payload),
  sendOtp: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`verifyOtp`, payload),
  storeOrder: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`storeOrder`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${payload.token}`,
      },
    }),
  getOrders: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`order/getOrders`, {
      all: payload.all,
      phoneCustomer: payload.phoneCustomer,
      domain: payload.domain,
    }),
  showOrder: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`/getOrder`, payload, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      //   Authorization: `Bearer ${payload.token}`,
      // },
    }),
};

export default orderServices;
